import React from 'react';
import { Field, reduxForm } from 'redux-form';
import focusInputOnError from '../helpers/focusInputOnError';
import validate from '../helpers/quoteFormValidate';
import { formatRut } from '../helpers/utils';
import { parseStringToNumber } from '../helpers/utils';
import { FormInput, FormNumber, FormRadio } from './';

export function QuoteForm(props: any) {
  const { handleSubmit } = props;

  return (
    <form onSubmit={handleSubmit} noValidate={true}>
      <div className="row flex-column">
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="fullName">Nombres y apellidos</label>
          <Field
            name="fullName"
            type="text"
            placeholder="León Maximiliano Vallejos Ramírez"
            component={FormInput}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="documentId">Rut</label>
          <Field
            name="documentId"
            type="text"
            placeholder="Ej 12.345.678-9"
            component={FormInput}
            normalize={formatRut}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="birthdate">Fecha de nacimiento</label>
          <Field
            name="birthdate"
            placeholder="31-12-2000"
            inputFormat="##-##-####"
            mask={['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a']}
            component={FormNumber}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="mail">Correo</label>
          <Field
            name="mail"
            type="mail"
            placeholder="ejemplo@dominio.com"
            component={FormInput}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="phone">Teléfono</label>
          <Field
            name="phone"
            placeholder="941234567"
            inputFormat="#########"
            isPhone={true}
            component={FormNumber}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="genre">Género</label>
          <div className="w-100 genre-checkbox-container">
            <Field
              name="genre"
              options={[
                {
                  id: 'male',
                  text: 'Masculino',
                  value: 'Male',
                },
                {
                  id: 'female',
                  text: 'Femenino',
                  value: 'Female',
                },
              ]}
              component={FormRadio}
            />
          </div>
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <label htmlFor="address">Dirección</label>
          <Field
            name="address"
            component={FormInput}
            placeholder="Ej. Avenida Libertador Bernardo O’Higgins"
          />
        </div>
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 form-group mx-auto mb20">
          <div className="row">
            <div className="col-6">
              <label htmlFor="addressNumber">Número</label>
              <Field
                name="addressNumber"
                placeholder="Ej. 1234"
                inputFormat="#######"
                normalize={parseStringToNumber}
                component={FormNumber}
              />
            </div>
            <div className="col-6">
              <label htmlFor="appartmentNumber">Nº Depto (opcional)</label>
              <Field
                name="appartmentNumber"
                placeholder="Ej. 14"
                inputFormat="#####"
                normalize={parseStringToNumber}
                component={FormNumber}
              />
            </div>
            <div className="col-12 mt50">
              <p className="text-dark-gray text-center mb0">
                <small>* El pagador debe ser igual al asegurado</small>
              </p>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-8 col-md-3 col-lg-5 form-group mx-auto mt00">
          <button id="quote" className="btn primary" type="submit">
            Continuar
          </button>
        </div>
        <div className="col-12 mt20">
          <p className="px-14 text-dark-gray text-center">
            Pago exclusivo con:
          </p>
          <div className="row">
            <div className="col-10 col-sm-6 col-md-4 col-lg-3 justify-content-center align-items-center d-flex mx-auto">
              <img
                src="//sfestaticos.blob.core.windows.net/guideline/payment-logos/CMR.svg"
                alt="Tarjeta CMR"
                width="70px"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default reduxForm({
  form: 'quote',
  onSubmitFail: focusInputOnError,
  validate,
})(QuoteForm);
